import { render } from "./ContentCopy.vue?vue&type=template&id=0d6b91c2"
import script from "./ContentCopy.vue?vue&type=script&lang=js"
export * from "./ContentCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ContentCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d6b91c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d6b91c2', __exports__)) {
    api.reload('0d6b91c2', __exports__)
  }
  
  module.hot.accept("./ContentCopy.vue?vue&type=template&id=0d6b91c2", () => {
    api.rerender('0d6b91c2', render)
  })

}


export default __exports__